"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireDefault(require("react"));
var _CheckCircleImage = require("./CheckCircleImage");
var _SVBButton = require("../../SVBButton");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const SVBAPIProductMainUse = props => {
  var _props$title, _props$slogan, _props$description, _props$buttonTitle, _props$color, _props$image, _props$buttonStyle, _props$buttonIconClas, _props$buttonRightIco;
  const {
    enableWhiteFont = false
  } = props;
  const title = (_props$title = props === null || props === void 0 ? void 0 : props.title) !== null && _props$title !== void 0 ? _props$title : "";
  const slogan = (_props$slogan = props === null || props === void 0 ? void 0 : props.slogan) !== null && _props$slogan !== void 0 ? _props$slogan : "";
  const description = (_props$description = props === null || props === void 0 ? void 0 : props.description) !== null && _props$description !== void 0 ? _props$description : [];
  const buttonTitle = (_props$buttonTitle = props === null || props === void 0 ? void 0 : props.buttonTitle) !== null && _props$buttonTitle !== void 0 ? _props$buttonTitle : "";
  const handleButtonPress = props === null || props === void 0 ? void 0 : props.handleButtonPress;
  const color = (_props$color = props === null || props === void 0 ? void 0 : props.color) !== null && _props$color !== void 0 ? _props$color : "green";
  const image = (_props$image = props === null || props === void 0 ? void 0 : props.image) !== null && _props$image !== void 0 ? _props$image : "";
  const fontStyle = enableWhiteFont ? "product-font-color-white" : " ";
  const buttonItemStyle = (_props$buttonStyle = props === null || props === void 0 ? void 0 : props.buttonStyle) !== null && _props$buttonStyle !== void 0 ? _props$buttonStyle : " ";
  const buttonRightIconClasses = (_props$buttonIconClas = props === null || props === void 0 ? void 0 : props.buttonIconClasses) !== null && _props$buttonIconClas !== void 0 ? _props$buttonIconClas : "product-main-right-icon";
  const buttonRightIconName = (_props$buttonRightIco = props === null || props === void 0 ? void 0 : props.buttonRightIconName) !== null && _props$buttonRightIco !== void 0 ? _props$buttonRightIco : "down";
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "row container justify-self-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-5"
  }, /*#__PURE__*/_react.default.createElement("h1", {
    className: "heading-xxxlarge " + fontStyle
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    className: "product-main-title-highlighter mt-3 pm-bg-".concat(color)
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "pt-3 heading-medium font-family-roboto rl-font-black " + fontStyle
  }, slogan), /*#__PURE__*/_react.default.createElement("div", null, description === null || description === void 0 ? void 0 : description.map(item => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "d-flex flex-row align-self-center"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "product-main-padding-right"
    }, /*#__PURE__*/_react.default.createElement(_CheckCircleImage.CheckCircleImage, {
      color: "#4BAF46"
    })), /*#__PURE__*/_react.default.createElement("p", {
      className: "sub-heading-medium font-family-roboto rl-font-black " + fontStyle
    }, item));
  })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_SVBButton.SVBButton, {
    extraClasses: "border-0 font-family-roboto pm-bg-" + color + " " + buttonItemStyle,
    text: buttonTitle,
    rightIconExtraClasses: buttonRightIconClasses,
    size: "large",
    style: "primary",
    state: "default",
    type: "text",
    icon: buttonRightIconName,
    iconSide: "right",
    onClick: handleButtonPress
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm d-flex justify-content-center"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: image
  })));
};
var _default = SVBAPIProductMainUse;
exports.default = _default;